import _ from 'lodash';
import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';

import { mapProps } from '../theme'
import logotypeSVGURL from '../assets/logotype4.svg'

import Block from './Block'

export const Logotype = styled(Block)`
  background-image: url(${logotypeSVGURL});
  background-size: contain;
  background-repeat: no-repeat;
  ${mapProps({
    size: (size: number | string) => css`
      min-height: ${size}rem;
      max-height: ${size}rem;
      min-width: ${_.ceil(2.33 * size)}rem;
      margin-bottom: -${0.2 * size}rem;`,
  })};
`

export default Logotype



// WEBPACK FOOTER //
// ./src/styleguide/Logotype.js